import axios from "axios";
import {partnerPlatformBaseUrl} from "../constants/defaultValues";
import {useAmplifyConfig} from "../hooks/useAmplifyConfig";
import {useAuthContext} from "../contexts/AuthContext";
import {QueryClient} from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchInterval: false,
      refetchIntervalInBackground: false,
      retry: false,
    },
  },
});

export const axiosPartnerPlatformInstance = axios.create({
  baseURL: partnerPlatformBaseUrl,
});

const ServerApiManager = () => {
  const {partnerCode, session} = useAuthContext();
  useAmplifyConfig();

  if (partnerCode) {
    axiosPartnerPlatformInstance.defaults.headers.common["PartnerId"] = partnerCode;
  }

  if (session?.tokens?.accessToken) {
    axiosPartnerPlatformInstance.defaults.headers.common["Authorization"] = `Bearer ${session?.tokens?.accessToken}`;
  } else {
    delete axiosPartnerPlatformInstance.defaults.headers.common["Authorization"];
  }

  return null;
};

export default ServerApiManager;
